import { Modal } from 'bootstrap'
import { appendInputGroup, createTable } from '../General/utils'
import { popoverInitialise } from '../General/utils'
import { savedPanel } from 'saved-panel-animations'
import { Grid } from 'gridjs'

let AddMailshotModal: Modal

window.addEventListener('load', () => {
    initialise()
})

const initialise = () => {
    const element = document.getElementById('MailshotTemplateTable') as HTMLTableElement
    const renderedID = createTable(element) as string
    new Grid({
        columns: [
            'File name',
            'Description',
            {
                name: '',
                sort: false
            }
        ],
        pagination: {
            limit: 200
        },
        sort: true,
        search: true,
        resizable: true,
        language: {
            search: {
                placeholder: 'Search...'
            },
            pagination: {
                previous: '<',
                next: '>',
                showing: '😃 Displaying',
                results: () => 'Records'
            }
        },
        from: element
    }).render(document.getElementById(renderedID)!)

    appendInputGroup(element.getAttribute('name')!)

    setTimeout(() => {
        popoverInitialise()
    }, 500)
    const btnAddMailshotModal = document.querySelector('.btnAddMailshotModal') as HTMLButtonElement
    if (btnAddMailshotModal != null) {
        btnAddMailshotModal.addEventListener('click', () => {
            const AddMailshotModalDiv = document.querySelector(
                '.AddMailshotModal'
            ) as HTMLFormElement
            AddMailshotModal = new Modal(AddMailshotModalDiv, {
                backdrop: true,
                keyboard: true
            })
            AddMailshotModal.show()
        })
    }
    const btnAddMailshotTemplate = document.querySelector('.btnAddMailshotTemplate') as HTMLButtonElement
    if (btnAddMailshotTemplate != null) {
        btnAddMailshotTemplate.addEventListener('click', () => {
            const form = document.querySelector('.formUploadMailshot') as HTMLFormElement
            const hidUpload = document.getElementById('hidUpload') as HTMLInputElement
            fetch(hidUpload.value.toString(), {
                method: 'POST',
                body: new FormData(form)
            })
                .then(() => {
                    AddMailshotModal.hide()
                    setTimeout(() => {
                        savedPanel()
                        setTimeout(() => {
                            window.location.reload()
                        }, 2000)
                    }, 500)
                })
                .catch((ex) => {
                    alert('Failed calling /Accounts/UpdateInvoiceDetail: ' + ex)
                })
        })
    }
}
